import React from 'react';
import {createGlobalStyle} from 'styled-components';


 
const GlobalStyle = createGlobalStyle`

  body {
    height: ${props => props.hei};
    overflow: ${props => props.overF}
  }


 `

 const GetGlobalStyle = ({hei, overF}) => {

    return (
        <>
<GlobalStyle 
hei={hei}
overF={overF} 
/>
        </>
    )
 }

 export default GetGlobalStyle